module.exports = __webpack_public_path__ + "img/product-0-2.dab5d3b2.jpg";